import { APP_ROUTES } from "@/core/constants";
import type { AppRouteDefinition } from "@/core/router";

import {
  CategoriesPage,
  ReviewQueuePage,
  TemplateCatalogPage,
  VerticalsPage,
} from "../views";
import { createTemplatePacksRoutes } from "../views/template-packs/router";

export const libraryRoutes: readonly AppRouteDefinition[] = [
  {
    route: APP_ROUTES.superAdmin.library.index,
  },
  {
    route: APP_ROUTES.superAdmin.library.verticals,
    element: <VerticalsPage />,
  },
  {
    route: APP_ROUTES.superAdmin.library.categories,
    element: <CategoriesPage />,
  },
  {
    route: APP_ROUTES.superAdmin.library.review,
    element: <ReviewQueuePage />,
  },
  {
    route: APP_ROUTES.superAdmin.library.templates,
    element: <TemplateCatalogPage />,
  },
  createTemplatePacksRoutes("super-admin"),
] as const;
